import { ButtonMain } from '@/modules/common/components/button';
import { PageTemplate } from '@/shared/ui/templates';
import styles from './index.module.sass';
import { TopInfo } from '@@/mixing/components/mixer/components/top-info';
import { ComponentCard } from '../../components/mixer/components/component-card';
import { SleevesList } from '../../components/mixer/components/sleeves-list';
import { useStore } from 'effector-react';
import {
  $recipeMixData,
  $selectedMix,
  fetchRecipeMixById,
  $recipeMixDataLoadingStatus,
} from '../../store/recipes.store';
import { createMixOfferFoo } from '../../components/bunker-recipe/components/total-card/create-mix-offer.function';
import { notification } from 'antd';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
import { $topRecipesForWarehouse } from '@/widgets/recipe/model';

export const MixerPage = () => {
  const navigate = useNavigate();
  const selectedMix = useStore($selectedMix);
  const recipeMixData = useStore($recipeMixData);
  const recipeMixDataloadingStatus = useStore($recipeMixDataLoadingStatus);
  const topRecipesData = useStore($topRecipesForWarehouse);

  const { id } = useParams();
  const [params] = useSearchParams();
  const ifViewOnly = !!(params.get('viewOnly'));

  useEffect(() => {
    if (id) {
      fetchRecipeMixById(+id);
    }
  }, [id]);


  useEffect(() => {
    if (recipeMixDataloadingStatus.error)
      return notification.warning({
        message: 'При загрузке данных произошла ошибка. Попробуйте, пожалуйста, позже',
      });
  }, [recipeMixDataloadingStatus]);

  return (
    <PageTemplate
      customBack={ ifViewOnly ? -1 : "/mixing/recipes-new"}
      header="Рецепт миксования в миксере"
      className={styles.root}
      // customAction={{ label: 'сохранить как', action: () => {} }}
    >
      {recipeMixDataloadingStatus.loading || recipeMixDataloadingStatus.error ? (
        <UniversalLoader error={recipeMixDataloadingStatus.error} />
      ) : (
        <>
          <div className={styles.contentWrap}>
            <div className={styles.topArea}>
              <TopInfo />
            </div>
            <div className={styles.bottomArea}>
              <div className={styles.leftArea}>
                <ComponentCard
                  i={0}
                  price={recipeMixData?.price_a}
                  data={recipeMixData?.bag_a}
                  params={recipeMixData?.bag_a_components}
                  variant="blue"
                />
                <SleevesList data={selectedMix?.components[0].bags} />
              </div>
              <div className={styles.rightArea}>
                <ComponentCard
                  i={1}
                  price={recipeMixData?.price_b}
                  data={recipeMixData?.bag_b}
                  params={recipeMixData?.bag_b_components}
                  variant="red"
                />
                <SleevesList data={selectedMix?.components[1].bags} />
              </div>
            </div>
          </div>
          {!ifViewOnly && <ButtonMain
            className={styles.mainAction}
            label="использовать рецепт"
            onClick={async () => {
              if (selectedMix && recipeMixData) {
                await createMixOfferFoo(
                  selectedMix,
                  'mix',
                  topRecipesData?.mix_signature,
                  recipeMixData.mix.mixed_properties,
                );
                navigate('/mixing/recipes-new');
              } else {
                notification.error({
                  message: 'Что-то пошло не так. Выбранный микс не найден',
                });
              }
            }}
          />}
        </>
      )}
    </PageTemplate>
  );
};
